module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "doctors",
    attrs: {
      "id": "doctors"
    }
  }, [_c('Doctor', {
    attrs: {
      "doctor": _vm.doctor,
      "type": 1,
      "id": _vm.doctorId
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con border2"
  }, [_c('h2', [_vm._v("执业医院")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.doctor.hospital))])]), _vm._v(" "), _c('div', {
    staticClass: "con"
  }, [_c('h2', [_vm._v("专业领域")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.doctor.good_at))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f59e1c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Doctors.vue
// module id = 597
// module chunks = 1